import { NgModule } from '@angular/core';
import { IonicApp, IonicModule } from 'ionic-angular';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { TermsPopover } from '../pages/terms/terms';
import { RoiPage } from '../pages/roi/roi';

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    TermsPopover,
    RoiPage
  ],
  imports: [
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    TermsPopover,
    RoiPage

  ],
  providers: []
})
export class AppModule {}
